<template>
    <div class="form-group row">
        <label class="col-sm-2 col-form-label">Parent Gaji</label>
        <div class="col-sm-4">
            <v-select size="sm" v-model="internalValue" :state="validation.parent ? false : null" :options="options" placeholder="Semua" label="text">
            </v-select>
            <span class="text-danger">{{ isUndefined(errors) }}</span>
        </div>
    </div>
</template>

<script>
  import vSelect from "vue-select";
  export default {
    data() {
      return {
        options:  [],
      }
    },
    props: {
      value: {
        type: Object
      },
      errors: {
        type: Array
      },
      validation: {
        type: Object
      }
    },
    computed: {
      internalValue: {
        get: function () {
          return this.value;
        },
        set: function (data) {
          this.$emit('values',data);
        }
      }
    },
    components: {
      vSelect
    },
    methods: {
      GetAllGrade() {
        this.options    =   [];
        let req         =   {
          params: {
            size: 999
          }
        };
        this.$http.get('/mastering/salaryStandard/findAll',req)
          .then((result) => {
            for (let i = 0; i < result.data.data.content.length; i++) {
              this.options.push({
                text:  result.data.data.content[i].jobTitle.subJobGrade,
                value: result.data.data.content[i]
              });
            }
          });
      },
      isUndefined(data) {
        if (data !== undefined) {
          return data[0];
        }
      }
    },
    mounted() {
      this.GetAllGrade();
    }
  }
</script>
